import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

import { SharedModule } from '../../../../../shared/shared.module';
import { ManualAuditIssuesRoutingModule } from './manual-audit-issues.routing';
import { CommentSectionModule } from './comment-section/comment-section.module';
import { ViewManualAuditIssueComponent } from './view/view-manual-audit-issue.component';
import { ManualRuleDetailsComponent } from './rule-details/manual-rule-details.component';
import { EditableManualRuleDetailsComponent } from './editable-rule-details/editable-manual-rule-details.component';
import { EditManualAuditIssueComponent } from './view/edit/edit-manual-audit-issue.component';
import { ScanResultsModule } from '../../../scans/scan-results/scan-results.module';
import { BulkChangeStatusModalComponent } from './bulk-change-status-modal/bulk-change-status-modal.component';
import { TaskStatusChangedBannerComponent } from './task-status-changed-banner/task-status-changed-banner.component';
import { DeleteConfirmDialogComponent } from './view/delete-confirm-dialog.component';
import { BulkTaskCreationSlideoutComponent } from './bulk-task-creation-slideout/bulk-task-creation-slideout.component';
import { ManualAuditIssuesComponent } from './manual-audit-issues.component';
import { IssueReportFieldSelectorComponent } from './issue-report-field-selector/issue-report-field-selector.component';
import { IssueTableColumnSelectorComponent } from './issue-table-column-selector/issue-table-column-selector.component';
import { FindingsTableComponent } from './findings-table/findings-table.component';
import { LinkedTaskCommentsComponent } from './view/linked-task-comments/linked-task-comments.component';

@NgModule({
  imports: [CommonModule, SharedModule, CommentSectionModule, ManualAuditIssuesRoutingModule, ScanResultsModule],
  declarations: [
    ManualAuditIssuesComponent,
    IssueReportFieldSelectorComponent,
    IssueTableColumnSelectorComponent,
    FindingsTableComponent,
    BulkTaskCreationSlideoutComponent,
    ViewManualAuditIssueComponent,
    TaskStatusChangedBannerComponent,
    ManualRuleDetailsComponent,
    EditableManualRuleDetailsComponent,
    EditManualAuditIssueComponent,
    BulkChangeStatusModalComponent,
    DeleteConfirmDialogComponent,
    LinkedTaskCommentsComponent,
  ],
  providers: [TitleCasePipe],
})
export class ManualAuditIssuesModule {}
